// extracted by mini-css-extract-plugin
export default {"error":"MultipleChoiceQuestion_error__Aq3L4"};